import { AgentKnowledgeSource } from "@redotech/crdb-enums/agent-knowledge/agent-knowledge-source";
import { AgentKnowledgeStatus } from "@redotech/crdb-enums/agent-knowledge/agent-knowledge-status";
import { managedKnowledgeSortSchema } from "@redotech/shopper-agent-knowledge-common/knowledge-sort";
import { managedKnowledgeListItemSchema } from "@redotech/shopper-agent-knowledge-common/managed-knowledge-view";
import * as z from "zod";

/**
 * The library itself. The review queue is paged separately by
 * `listSuggestedKnowledge`, so nothing unreviewed appears among these items.
 */
export const listKnowledge = {
  name: "listKnowledge" as const,
  input: z.object({
    /** Present switches to index-backed search; absent browses the table. */
    query: z.string().optional(),
    types: z.array(z.enum(AgentKnowledgeSource)).optional(),
    statuses: z.array(z.enum(AgentKnowledgeStatus)).optional(),
    /** Ignored alongside `query`, which the index ranks. Newest first when absent. */
    sort: managedKnowledgeSortSchema.optional(),
    limit: z.number().int().positive().optional(),
    offset: z.number().int().nonnegative().optional(),
  }),
  output: z.object({
    /** Every corpus in one paged order, tagged by `type` — FAQ is read-only. */
    items: z.array(managedKnowledgeListItemSchema),
    /** Items matching the query and filters, for the pager. */
    totalItemCount: z.number(),
  }),
};
